import dayjs from "@lib/dayjs";

const ActivityTracker = () => {
  return (
    <div className="flex flex-col items-center min-h-0">
      <span className="font-semibold">Activity Tracker</span>
      <div className="flex flex-col overflow-y-scroll no-scrollbar mt-5 gap-6 min-h-0">
        {Array.from({ length: 20 })?.map(() => {
          return (
            <div className="flex flex-col gap-2">
              <span className="font-medium text-xs text-light-black">
                {dayjs().format("hh:mma DD MMM YY")}
              </span>
              <div className="text-xs font-medium text-charcoal bg-light-white-700 rounded-md p-3.5">
                <span className="font-bold text-xs">Joe Bloggs</span>
                &nbsp;&nbsp; accepted your invitation and is now part of your
                network.
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ActivityTracker;
